// src/pages/Teams.js
import { useState, useEffect, useContext } from 'react';
import axios from 'axios';
import { useAuth } from '../context/AuthContext';

import { FiPlus, FiUsers, FiSearch } from 'react-icons/fi';
import TeamCard from '../components/supervisor/TeamCard';
import CreateTeamModal from '../components/supervisor/CreateTeamModal';
import { fetchAllTeams } from '../services/action';


const Teams = () => {
  const { user } = useAuth();
  const [teams, setTeams] = useState([]);
  const [loading, setLoading] = useState(true);
  const [searchTerm, setSearchTerm] = useState('');
  const [isModalOpen, setIsModalOpen] = useState(false);

  const styles = `
  .teams-container {
    padding: 2rem 0;
  }

  .search-input-container {
    position: relative;
    margin-bottom: 1.5rem;
  }

  .search-icon {
    position: absolute;
    left: 10px;
    top: 50%;
    transform: translateY(-50%);
    color: #6c757d;
  }

  .create-team-btn {
    display: flex;
    align-items: center;
    gap: 8px;
  }

  .spinner {
    width: 3rem;
    height: 3rem;
    border: 0.25em solid currentColor;
    border-right-color: transparent;
    border-radius: 50%;
    animation: spin 1s linear infinite;
  }

  @keyframes spin {
    from { transform: rotate(0deg); }
    to { transform: rotate(360deg); }
  }

  .empty-state {
    text-align: center;
    padding: 3rem 0;
  }

  .empty-state-icon {
    margin: 0 auto 1rem;
    color: #6c757d;
  }
`;

  useEffect(() => {
    const getTeams = async () => {
      try {
        const res = await fetchAllTeams();
        setTeams(res.data.data);
      } catch (err) {
        console.error(err);
      } finally {
        setLoading(false);
      }
    };

    getTeams();
  }, []);

  const filteredTeams = teams.filter(team =>
    team.name.toLowerCase().includes(searchTerm.toLowerCase())
  );

  const handleTeamCreated = (newTeam) => {
    setTeams([newTeam, ...teams]);
  };
  console.log("user role:",user.role);

  return (
    <div className="container teams-container">
      <style>{styles}</style>
      
     <div className="d-flex justify-content-between align-items-center mb-4">
        <h1 className="h2 mb-0">Teams</h1>
        {user?.role === 'supervisor' && (  // Changed condition to check admin role
          <button
            onClick={() => setIsModalOpen(true)}
            className="btn btn-primary create-team-btn"
          >
            <FiPlus /> Create Team
          </button>
        )}
      </div>

      <div className="search-input-container">
        <FiSearch className="search-icon" />
        <input
          type="text"
          placeholder="Search teams..."
          className="form-control ps-5"
          style={{ maxWidth: '500px' }}
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
        />
      </div>

      {loading ? (
        <div className="d-flex justify-content-center align-items-center" style={{ height: '256px' }}>
          <div className="spinner"></div>
        </div>
      ) : filteredTeams.length === 0 ? (
        <div className="empty-state">
          <FiUsers className="empty-state-icon" size={48} />
          <h3 className="h4 mt-2 mb-1">No teams found</h3>
          <p className="text-muted">
            {searchTerm ? 'Try a different search term' : 'Get started by creating a new team'}
          </p>
        </div>
      ) : (
        <div className="row g-4">
          {filteredTeams.map(team => (
            <div className="col-12 col-md-6 col-lg-4" key={team._id}>
              <TeamCard team={team} />
            </div>
          ))}
        </div>
      )}

      <CreateTeamModal 
        isOpen={isModalOpen} 
        onClose={() => setIsModalOpen(false)} 
        onTeamCreated={handleTeamCreated} 
      />
    </div>
  );
};


export default Teams;